import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import LineItemTypeStep from '../../LineItemTypeStep'
import DatesStep from '../../DatesStep'
import TargetingOptionsStep from '../../TargetingOptionsStep'

import { getQuantityAllocationInventoryTargetingSteps } from './getQuantityAllocationInventoryTargetingSteps'

import { rightSelector } from '../../../../../../../../modules/selectors/rights'
import {
  CUSTOM_TARGETING_ENABLED,
  DEVICE_TARGETING_ENABLED,
  GEO_TARGETING_ENABLED
} from '../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const useQuantityAllocationSteps = () => {
  const right = useSelector(rightSelector)
  const rightAdvancedSettings = right?.advanced_settings || {}

  const {
    [GEO_TARGETING_ENABLED]: geoTargetingEnabled,
    [DEVICE_TARGETING_ENABLED]: deviceTargetingEnabled,
    [CUSTOM_TARGETING_ENABLED]: customTargetingEnabled
  } = rightAdvancedSettings

  const skipTargetingOptions = !geoTargetingEnabled && !deviceTargetingEnabled && !customTargetingEnabled

  const inventoryTargetingStep = getQuantityAllocationInventoryTargetingSteps(right)

  return useMemo(
    () => [
      {
        component: <LineItemTypeStep />,
        show: true
      },
      {
        component: <DatesStep showContinueButton={true} />,
        show: true
      },
      {
        component: <TargetingOptionsStep />,
        show: !skipTargetingOptions
      },
      inventoryTargetingStep
    ],
    [inventoryTargetingStep, skipTargetingOptions]
  )
}
